import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TabMessagesPage } from './tab-messages';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		TabMessagesPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(TabMessagesPage),
	],
})
export class TabMessagesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/tab-messages/tab-messages.module.ts